import { openComponentInPopup, QueryParameter } from "./common";
import Form from "./form";
import { PopupWidth } from "./popup";

export class ProductSampleInquiryForm {
    private componentName: string = 'ProductSampleInquiryForm';
    private componentId: string = 'product-sample-inquiry-form';
    private productId: number;

    constructor(productId: number) {
        this.productId = productId;
    }

    async openInPopup(event: Event, queryParameters: QueryParameter[] = null): Promise<void> {
        event?.preventDefault();

        await openComponentInPopup(this.componentName, queryParameters, { id: this.componentId, width: PopupWidth.Medium }, true);
        this.subscribeForm();
    }

    private subscribeForm(): void {
        const formElement = document.querySelector('[data-popup] form') as HTMLFormElement;
        const actionUrl = formElement.getAttribute('action');
        const url = `${actionUrl}/${this.productId}`;

        const form = new Form(url, formElement, 
            () => this.onSuccess(),
            (html: string) => this.onModelError(html));

        form.subscribeAndProcess();
    }

    private onSuccess(): void {
        this.displaySuccessMessage();
    }

    private onModelError(html: string): void {
        const viewcomponent = document.querySelector(`[data-component=${this.componentName}]`);
        viewcomponent.innerHTML = html;
        this.subscribeForm();
    }

    private displaySuccessMessage(): void {
        const successMessageElement = document.getElementById('success-message');
        const form = document.getElementById('inquiry-form');

        successMessageElement.style.display = 'block';
        form.style.display = 'none';
    }
}
